import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

const supportedActions = [
  'GET_MODERATORS',
  'GET_OLDER_MODERATORS',
  'CLEAR_MODERATORS',
];

export const consts = createReqConsts(
  'communities',
  'communityModerators',
  supportedActions,
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'communities',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['communityId'],
    },
    'moderators',
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/communities/communityModerators.js